/* eslint-disable func-names */
import {
  ADD_PLANNED_DATA,
  FETCH_PLAN_SCHEDULE,
  FETCH_PLAN_LIST,
  FETCH_DETAIL,
  UPDATE_DATA,
  GET_TEMPLATE,
  FETCH_GATES_LIST,
  GET_AIRPORTS_DATA,
  FETCH_REQUEST_LOGS,
  GET_REQUEST_LOG,
  GATE_REQUEST_UPDATE,
  FETCH_ALLOCATION_DATA,
  CLEAR_DATA
} from './types';

import { actionForState } from '../../../utils/helpers';

const INITIAL_STATE = {
  saveAction: {
    success: false,
    loading: false,
    error: false
  },
  updateAction: {
    success: false,
    loading: false,
    error: false
  },
  scheduleaction: {
    success: false,
    loading: false,
    error: false
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_PLANNED_DATA.pending:
      return {
        ...state,
        saveAction: actionForState(state.action, 'pending')
      };
    case ADD_PLANNED_DATA.success:
      return {
        ...state,
        saveAction: actionForState(state.action, 'success')
      };
    case ADD_PLANNED_DATA.error:
      return {
        ...state,
        saveAction: actionForState(state.action, 'error')
      };

      case FETCH_PLAN_SCHEDULE.pending:
      return {
        ...state,
        scheduleaction: actionForState(state.action, 'pending')
      };
    case FETCH_PLAN_SCHEDULE.success: {
      return {
        ...state,
        scheduleaction: actionForState(state.action, 'success'),
        planSchedule: action.payload
      };
    }
    case FETCH_PLAN_SCHEDULE.error:
      return {
        ...state,
        scheduleaction: actionForState(state.action, 'error')
      };

      case FETCH_PLAN_LIST.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case FETCH_PLAN_LIST.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        list: action.payload
      };
    }
    case FETCH_PLAN_LIST.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };

      case FETCH_DETAIL.pending:
        return {
          ...state,
          getdetailaction: actionForState(state.action, 'pending')
        };
      case FETCH_DETAIL.success: {
        return {
          ...state,
          getdetailaction: actionForState(state.action, 'success'),
          detail: action.payload
        };
      }
      case FETCH_DETAIL.error:
      return {
        ...state,
        getdetailaction: actionForState(state.action, 'error')
      };
      case UPDATE_DATA.pending:
        return {
          ...state,
          updateAction: actionForState(state.action, 'pending')
        };
      case UPDATE_DATA.success:
        return {
          ...state,
          updateAction: actionForState(state.action, 'success')
        };
      case UPDATE_DATA.error:
        return {
          ...state,
          updateAction: actionForState(state.action, 'error')
        };
        case GET_TEMPLATE.pending:
        return {
          ...state,
          templateAction: actionForState(state.action, 'pending')
        };
      case GET_TEMPLATE.success:
        return {
          ...state,
          templateAction: actionForState(state.action, 'success'),
          scheduleUrl: action.payload
        };
      case GET_TEMPLATE.error:
        return {
          ...state,
          templateAction: actionForState(state.action, 'error')
        };
      case FETCH_GATES_LIST.success:
        return {
          ...state,
          gateList: action.payload
        };
      case GET_AIRPORTS_DATA.pending:
        return {
          ...state,
          airportDataAction: actionForState(state.action, 'pending')
        };
      case GET_AIRPORTS_DATA.success: {
        return {
          ...state,
          airportDataAction: actionForState(state.action, 'success'),
          airports_data: action.payload
        };
      }
      case GET_AIRPORTS_DATA.error:
        return {
          ...state,
          airportDataAction: actionForState(state.action, 'error')
        };
      case FETCH_REQUEST_LOGS.pending:
        return {
          ...state,
          RequestListAction: actionForState(state.action, 'pending')
        };
      case FETCH_REQUEST_LOGS.success: {
        return {
          ...state,
          RequestListAction: actionForState(state.action, 'success'),
          gateRequests: action.payload
        };
      }
      case FETCH_REQUEST_LOGS.error:
        return {
          ...state,
          RequestListAction: actionForState(state.action, 'error')
        };
      case GET_REQUEST_LOG.pending:
        return {
          ...state,
          RequestDetailAction: actionForState(state.action, 'pending')
        };
      case GET_REQUEST_LOG.success: {
        return {
          ...state,
          RequestDetailAction: actionForState(state.action, 'success'),
          gateRequest: action.payload
        };
      }
      case GET_REQUEST_LOG.error:
        return {
          ...state,
          RequestDetailAction: actionForState(state.action, 'error')
        };
      case GATE_REQUEST_UPDATE.pending:
        return {
          ...state,
          createGateRequestAction: actionForState(state.action, 'pending')
        };
      case GATE_REQUEST_UPDATE.success: {
        return {
          ...state,
          createGateRequestAction: actionForState(state.action, 'success')
        };
      }
      case GATE_REQUEST_UPDATE.error:
        return {
          ...state,
          createGateRequestAction: actionForState(state.action, 'error')
        };
      case FETCH_ALLOCATION_DATA.pending:
        return {
          ...state,
          allocationDataAction: actionForState(state.action, 'pending')
        };
      case FETCH_ALLOCATION_DATA.success: {
        return {
          ...state,
          allocationDataAction: actionForState(state.action, 'success'),
          allocationData: action.payload
        };
      }
      case FETCH_ALLOCATION_DATA.error: {
        return {
          ...state,
          allocationDataAction: actionForState(state.action, 'error')
        };
      }
      case CLEAR_DATA:
        return {
          ...state,
          updateAction: {
            success: false,
            loading: false,
            error: false
          },
          detail: {}
        };
    default:
      return state;
  }
}
